import { AxiosError, HttpStatusCode } from 'axios'

//todo: add email domain is top 100 domain(backend api) check process
export const openInbox = (email) => {
  const emailDomainRegx = /@\w+.\w+$/
  const emailDomainList = emailDomainRegx.exec(email)
  if (emailDomainList && emailDomainList.length > 0) {
    let emailDomain = emailDomainList[0].substring(1)
    window.open('https://www.'.concat(emailDomain), '_blank', 'noopener, noreferrer')
  }
}

export const openInBoxByDomain = (emailDomain) => {
  window.open(emailDomain, '_blank', 'noopener, noreferrer')
}

export const generateRandomString = (length: number) => {
  let randomString = ''
  const quotient = length / 10

  let i = 0
  while (i < quotient) {
    randomString += Math.random().toString(36).substring(2, 12)
    i++
  }

  return randomString.substring(0, length)
}

export const generateVersionCode = (version: string): string => {
  const normalizedVersion = version.trim()
  const paddedVersion = normalizedVersion.padEnd(10, '0')
  const numericCode = paddedVersion + normalizedVersion.length.toString().padStart(2, '0')

  const encoded = btoa(numericCode).slice(0, 8).toUpperCase().replace(/[/+]/g, 'X')

  return encoded.padEnd(8, '0')
}

export const maskingEmail = (email: string) => {
  const userName = email?.split('@')[0]
  const length = userName.length

  if (length === 0) {
    return ''
  }

  let result
  if (length <= 3) {
    result = '*'.repeat(userName.length)
  } else if (length <= 6) {
    result = userName.slice(0, length - 3) + '*'.repeat(3)
  } else {
    result = userName.slice(0, 3) + '*'.repeat(length - 3)
  }

  return email.replace(userName, result)
}

export const maskingPhoneNumber = (phoneNumber) => {
  if (!phoneNumber || phoneNumber.trim() === '') {
    throw new Error('Phone number is empty.')
  }

  if (/^[0-9]+$/.test(phoneNumber)) {
    return maskPhoneNumberWithOnlyNumbers(phoneNumber)
  }
  return maskPhoneNumberWithSpecialCharacters(phoneNumber)
}

const maskPhoneNumberWithOnlyNumbers = (phoneNumber) => {
  let maskedPhoneNumber = ''
  const phoneNumberLength = phoneNumber.length

  for (let i = 0; i < phoneNumberLength; i++) {
    if (
      i === phoneNumberLength - 3 ||
      i === phoneNumberLength - 4 ||
      i === phoneNumberLength - 7 ||
      i === phoneNumberLength - 8
    ) {
      maskedPhoneNumber += '*'
    } else {
      maskedPhoneNumber += phoneNumber.charAt(i)
    }
  }
  return maskedPhoneNumber
}

const maskPhoneNumberWithSpecialCharacters = (phoneNumber: string) => {
  const specialCharacterInfoQueue: { index: number; character: string }[] = []

  for (let i = 0; i < phoneNumber.length; i++) {
    if (/\d/.test(phoneNumber.charAt(i))) {
      continue
    }
    specialCharacterInfoQueue.push({ index: i, character: phoneNumber.charAt(i) })
  }

  const numericPhoneNumber = phoneNumber.replace(/\D/g, '')
  const maskedNumericPhoneNumber = maskPhoneNumberWithOnlyNumbers(numericPhoneNumber)
  let result = maskedNumericPhoneNumber.split('')

  for (const specialCharacterInfo of specialCharacterInfoQueue) {
    result.splice(specialCharacterInfo.index, 0, specialCharacterInfo.character)
  }

  return result.join('')
}

export const commaSeparateNumber = (point: number) => {
  let strPoint = point.toString()
  let point3Digit: any = []
  while (strPoint.length > 3) {
    let str3Digit = strPoint.substring(strPoint.length - 3)
    point3Digit.unshift(str3Digit)
    strPoint = strPoint.substring(0, strPoint.length - 3)
  }
  if (strPoint.length > 0) {
    point3Digit.unshift(strPoint)
  }
  return point3Digit.join(',')
}

export const base64ToArray = (value) => {
  return Uint8Array.from(
    atob(value)
      .split('')
      .map((c) => {
        return c.charCodeAt(0)
      })
  )
}

export const arrayToBase64 = (value) => {
  return btoa(new Uint8Array(value).reduce((s, byte) => s + String.fromCharCode(byte), ''))
}

// For country list, Please refer to https://confluence-mx.sec.samsung.net/pages/viewpage.action?pageId=1430042230

// prettier-ignore
const LATIN_AMERICA_COUNTRY_LIST = [
  'AG', 'AI', 'AN', 'AR', 'AW', 'BB', 'BM', 'BO', 'BQ', 'BR',
  'BS', 'BZ', 'CL', 'CO', 'CR', 'CU', 'CW', 'DM', 'DO', 'EC',
  'GF', 'GD', 'GP', 'GT', 'GY', 'HN', 'HT', 'JM', 'KN', 'KY',
  'LC', 'MS', 'MX', 'NI', 'PA', 'PE', 'PR', 'PY', 'SX', 'SR',
  'SV', 'TC', 'TT', 'UY', 'VC', 'VE', 'VG'
]

// prettier-ignore
const GDPR_COUNTRY_LIST = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE',
  'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT',
  'LV', 'LI', 'LT', 'LU', 'MT', 'NL', 'NO', 'PL',
  'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'CH', 'GB'
]

// prettier-ignore
const EU_COUNTRY_LIST = ['AL', 'AD', 'AT', 'BE', 'BA', 'BG', 'HR', 'CY', 'DK', 'EE', 'FK',
  'FO', 'FI', 'FR', 'PF', 'DE', 'GI', 'GR', 'GL', 'VA', 'HU', 'IE', 'IT', 'XK', 'LV', 'LT',
  'LU', 'MT', 'MD', 'MC', 'ME', 'NL', 'MK', 'PL', 'PT', 'RO', 'PM', 'SM', 'RS', 'SK', 'SI',
  'ES', 'SE', 'IS', 'LI', 'NO', 'CH', 'CZ', 'UA', 'GB'
]

// prettier-ignore
const CIS_COUNTRY_LIST = ['AM', 'AZ', 'BY', 'GE', 'KZ', 'KG', 'MN', 'TJ', 'TM', 'UZ', 'RU']

// prettier-ignore
const EAO_COUNTRY_LIST = ['HK', 'JP', 'TW', 'MO']

// prettier-ignore
const MENA_COUNTRY_LIST = ['AF', 'DZ', 'BH', 'EG', 'IR', 'IQ', 'IL', 'JO', 'KW', 'LB', 'LY', 'MA',
  'OM', 'PK', 'QA', 'SA', 'SY', 'TN', 'AE', 'YE']

// prettier-ignore
const SEAO_COUNTRY_LIST = ['BN', 'KH', 'CK', 'FJ', 'ID', 'KI', 'LA', 'MY', 'MH', 'FM', 'MM',
  'NR', 'NC', 'NZ', 'NU', 'PW', 'PG', 'PH', 'WS', 'SG', 'SB', 'TH', 'TL', 'TO', 'TV',
  'VU', 'VN'
]

// prettier-ignore
const SWA_COUNTRY_LIST = ['BD', 'BT', 'IN', 'MV', 'NP', 'LK']

// prettier-ignore
const REWARDS_COUNTRY_LIST = ['DE','GB','FR','IT','ES','PT','DK','FI','NO','SE',
'BE','NL','PL','AT','CH','RO','CZ','SK','EE','LT',
'LV','GR','HU','SI','HR','AE','OM','KW','BH','QA',
'JO','SA','MA','TR','ZA','RU','KZ','AU','TH','MY',
'PH','SG','NZ','VN','JP','TW','CL','MX','BR','CO',
'PE','CA','US'
]

export const isLatinAmericaCountry = (country: string) => {
  return LATIN_AMERICA_COUNTRY_LIST.findIndex((item) => item === country) !== -1
}

export const isEuCountry = (country: string) => {
  return EU_COUNTRY_LIST.findIndex((item) => item === country) !== -1
}

export const isEuCountryExcludeIT = (country: string) => {
  return EU_COUNTRY_LIST.findIndex((item) => item === country && item !== 'IT') !== -1
}

export function isGDPRCountry(country: string): boolean {
  return GDPR_COUNTRY_LIST.findIndex((item) => item === country) !== -1
}

export const isCisCountry = (country: string) => {
  return CIS_COUNTRY_LIST.findIndex((item) => item === country) !== -1
}

export const isEaoCountry = (country: string) => {
  return EAO_COUNTRY_LIST.findIndex((item) => item === country) !== -1
}

export const isMenaCountry = (country: string) => {
  return MENA_COUNTRY_LIST.findIndex((item) => item === country) !== -1
}

export const isSeaoCountry = (country: string) => {
  return SEAO_COUNTRY_LIST.findIndex((item) => item === country) !== -1
}

export const isSwaCountry = (country: string) => {
  return SWA_COUNTRY_LIST.findIndex((item) => item === country) !== -1
}

export const isRewardsCountry = (country: string) => {
  return REWARDS_COUNTRY_LIST.findIndex((item) => item === country) !== -1
}

const isRecognizedCountry = (countryCode: string, recognizedCountries: string[]) => {
  return recognizedCountries.includes(countryCode.toUpperCase())
}

export const isAuCaCountry = (countryCode: string) => {
  return isRecognizedCountry(countryCode, ['AU', 'CA'])
}

export const isAuCaUsCountry = (countryCode: string) => {
  return isRecognizedCountry(countryCode, ['AU', 'CA', 'US'])
}

export const validateUrl = (input: string) => {
  try {
    const url = new URL(input)

    // Open redirect blocking
    if (url.host !== window.location.host) {
      console.error('Host is not same')
      return ''
    }

    // XSS blocking
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      console.error('Protocol is not http or https')
      return ''
    }

    return url.toString()
  } catch (e) {
    console.error('Invalid URL')
    return ''
  }
}

export const isInvalidAuthorizedLevelError = (error: AxiosError) => {
  const data = error.response?.data as {
    message: string
  }

  let message
  try {
    message = JSON.parse(data?.message) as {
      code: string
    }
  } catch {
    return false
  }

  return error.response?.status === HttpStatusCode.Forbidden && message?.code === 'InvalidAuthorizedLevel'
}

export const debugLog = (message?: any, ...optionalParams: any[]) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(message, optionalParams)
  }
}

export const isWithinTimeRange = (start: number, end: number): boolean => {
  const now = Date.now()
  return now >= start && now < end
}

export const encodeStringInBase64AndUri = (input: string) => {
  const base64Encoded = btoa(input)
  return encodeURIComponent(base64Encoded)
}
